document.addEventListener("DOMContentLoaded", function() {
  function processNode(node) {
    node.childNodes.forEach(child => {
      if (child.nodeType === Node.TEXT_NODE && child.textContent.includes('[new]')) {
        // Remove [new] text
        child.textContent = child.textContent.replace('[new]', '').trim();

        // Add badge to parent <a> if not already added
        if(child.parentNode.tagName === 'A' && !child.parentNode.querySelector('.menu-new-badge')) {
          const badge = document.createElement('span');
          badge.className = 'menu-new-badge';
          badge.textContent = 'NEW';
          child.parentNode.appendChild(badge);
        }
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        processNode(child);
      }
    });
  }

  // All menu link selectors: desktop + mobile
  const menuSelectors = [
    '.site-nav__link',             // desktop top-level
    '.site-nav__dropdown-link',    // desktop child links
    '.mobile-nav__link',           // mobile top-level
    '.mobile-nav__child-link',     // mobile child links
    '.mobile-nav__dropdown-link'   // mobile deeper levels
  ];

  menuSelectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(link => {
      processNode(link);
    });
  });
});

